import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Menu, X } from "lucide-react";

export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSignIn = () => {
    navigate("/fancy-signin");
  };

  const handleGenerateLink = () => {
    navigate("/magic-onboarding-v2");
  };

  return (
    <header
      className={cn(
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300 ease-in-out w-full",
        isScrolled
          ? "py-3 glass-effect"
          : "py-5 bg-transparent"
      )}
    >
      <div className="container mx-auto px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img
            src="/uploads/figgy-logo.png"
            alt="Figgy Logo"
            className="h-7 sm:h-8 w-auto max-w-[180px]"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <div className="flex items-center gap-5">
            <Button 
              size="sm" 
              className="text-sm font-medium bg-figgy-500 hover:bg-figgy-600 text-white rounded-full px-6 py-2 transition-all duration-200 shadow-lg hover:shadow-xl" 
              onClick={handleSignIn}
            >
              Sign in
            </Button>
            <Button 
              size="sm" 
              className="text-sm font-medium bg-black hover:bg-gray-900 text-white btn-hover-effect rounded-full px-5" 
              onClick={handleGenerateLink}
            >
              Generate Link
            </Button>
          </div>
        </nav>

        <button
          className="md:hidden focus:outline-none"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? (
            <X className="h-6 w-6 text-foreground" />
          ) : (
            <Menu className="h-6 w-6 text-foreground" />
          )}
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 pt-20 glass-effect md:hidden animate-fade-in">
          <div className="container mx-auto px-6 py-8 flex flex-col gap-8">
            <div className="flex flex-col gap-4 mt-4">
              <Button 
                className="w-full justify-center bg-figgy-500 hover:bg-figgy-600 text-white rounded-full" 
                onClick={handleSignIn}
              >
                Sign in
              </Button>
              <Button 
                className="w-full justify-center bg-black hover:bg-gray-900 text-white rounded-full" 
                onClick={handleGenerateLink}
              >
                Generate Link
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

export default Navbar;
